


































































































































































// tslint:disable:no-console
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxLookup
} from 'devextreme-vue/data-grid';
import { DxItem, DxSimpleItem, DxGroupItem, DxLabel, DxButtonItem } from 'devextreme-vue/form';
import { DataSource } from '@/types';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { guid } from '@/core/helpers';
import { InactivityInterval, Site } from '@/dto';
import { IInactivityItem } from '@/pages/inactivityIntervals/types';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validator from 'devextreme/ui/validator';
import Validators from '@/core/helpers/validators';
import { DateTime } from 'luxon';
import Form from 'devextreme/ui/form';
import DxButton from 'devextreme-vue/button';

@Component({
    components: {
        DxDataGrid,
        DxButton,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxLabel,
        DxSimpleItem,
        DxGroupItem,
        DxButtonItem,
        DxRequiredRule,
        DxCustomRule,
        DxLookup
    }
})
export default class InactivityIntervalsListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: false }) public sites!: Site[];
    @Prop({ type: String, required: false, default: null }) public selectedAlias!: string | null;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    private startTime: DateTime | null = null;
    private finishTime: DateTime | null = null;
    private selectSiteId: string | null = null;
    private startValidator: Validator | null = null;
    private finishValidator: Validator | null = null;
    private selectValidator: Validator | null = null;
    private inactivities: IInactivityItem[] = [];
    private editingId: string | null = null;
    private form: Form | null = null;
    private tagInst: any = null;

    public inactivitiesOption(id: any) {
        return {
            position: id,
            name: this.inactivities[id]?.siteName,
            value: this.inactivities[id].shownText,
        };
    }

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
            stateStoring: {
                enabled: false
            }
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
        this.tableInstance.repaint();
    }

    public editinStart(e: any) {
        this.editingId = e.key;
    }

    public formInit(e: {component: Form}) {
        this.form = e.component;
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public clearBuffers() {
        this.inactivities = [];
        this.editingId = null;
    }

    public saving(e: any) {
        this.clearBuffers();
    }

    public popupDisposing(e: any) {
        this.clearBuffers();
    }

    public tagOptionsChanged(e: {component: any}) {
        if (this.tagInst === null) {
            this.tagInst = e.component;
        }
    }

    public addInactivityButton() {
        const formValidateResult = this.form?.validate();
        if (!formValidateResult?.isValid || formValidateResult === null) {
            return;
        }

        const finishms = Date.parse(this.finishTime!.toString());
        const startms = Date.parse(this.startTime!.toString());
        const startTimeStr = DateTime.fromMillis(startms).toFormat('yyyy-MM-dd HH:mm');
        const finishTimeStr = DateTime.fromMillis(finishms).toFormat('yyyy-MM-dd HH:mm');

        const maxId = this.inactivities?.reduce((max, curr) =>
                max = curr.listPosition! > max ? curr.listPosition! : max, 0);
        const siteName = this.sites.find(a => a.id === this.selectSiteId)?.name;
        const shownStr = `${startTimeStr} ${finishTimeStr}`;

        this.inactivities.push({
            id: '0',
            listPosition: maxId + 1,
            siteId: this.selectSiteId!,
            siteName: siteName as string,
            shownText: shownStr,
            finishTime: this.finishTime!,
            startTime: this.startTime!
        });

        this.startValidator?.reset();
        this.finishValidator?.reset();
        this.selectValidator?.reset();

        this.startValidator = null;
        this.finishValidator = null;
        this.selectValidator = null;

        this.finishTime = null;
        this.startTime = null;
        this.selectSiteId = null;
    }

    public deleteSelectedInactivity(index: number) {
        this.inactivities.splice(index, 1);
    }

    public saveSelectedInactivities() {
        let count = this.inactivities?.length;
        if (count === 0) {
            return;
        }
        this.inactivities?.forEach(item => {
            this.insert({
                id: '0',
                startTime: item.startTime!,
                finishTime: item.finishTime!,
                siteId: item.siteId!
            }).then(() => {
                count--;
                if (count === 0) {
                    this.clearBuffers();
                    this.dataSource.reload();
                }
            });
        });
    }

    public validateStartDate(e: {value: DateTime, validator: any}) {
        this.startTime = e.value;
        if (this.startValidator === null) {
            this.startValidator = e.validator;
        }
        return !this.isOvelappedDate();
    }

    public validateSelectSites(e: {value: string, validator: any}) {
        this.selectSiteId = e.value;
        if (this.selectValidator === null) {
            this.selectValidator = e.validator;
        }
        return !this.isOvelappedDate();
    }

    public validateFinishDate(e: {value: DateTime, validator: any}) {
        this.finishTime = e.value;
        if (this.finishValidator === null) {
            this.finishValidator = e.validator;
        }
        return !this.isOvelappedDate();
    }

    public isFinishAfterStartValidate() {
        if (this.finishTime !== null && this.startTime !== null) {
            if (this.finishTime < this.startTime) {
                return false;
            }
        }
        return true;
    }

    public isOvelappedDate() {
        return (this.dataSource.items()
            .concat(this.inactivities))
                .some((el: IInactivityItem) => {
                    if (this.editingId === el.id) { return false; }
                    return  (el.startTime! < this.startTime! && el.finishTime! > this.startTime! ||
                        el.startTime! < this.finishTime! && el.finishTime! > this.finishTime! ||
                        el.startTime! > this.startTime! && el.finishTime! < this.finishTime!) &&
                        (el.siteId === this.selectSiteId);
                    });
    }

    public initNewRow(row: any) {
        if (this.selectedAlias) {
            row.data.siteId = this.selectedAlias;
        }
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

public async insert(inactivityInterval: InactivityInterval) {
        if (this.selectedAlias) {
            inactivityInterval.siteId = this.selectedAlias;
        }
        inactivityInterval.id = guid();
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        const data = {
            InactivityIntervals_Partial: [inactivityInterval],
        };
        return await this._fetchService!.post<InactivityInterval>(
            url,
            JSON.stringify(data)
        );
    }

    public deleteInactivityInterval() {
        this._windowsService!.showDialog(
            localize('InactivityIntervalSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        ).then(id => {
            if (id === 1) {
                const incativityInterval = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    InactivityIntervals_Partial: [
                        {
                            id: incativityInterval.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<InactivityInterval>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }
}
